import * as storage from '../../utils/storage';

export const PWAInstallPrompt = ({
  showPWAPrompt,
  deferredPrompt,
  setShowPWAPrompt,
  setDeferredPrompt,
}) => {
  if (!showPWAPrompt || !deferredPrompt) return null;

  return (
    <div className="fixed inset-0 z-[200] bg-black/90 flex items-center justify-center p-4">
      <div className="bg-gradient-to-br from-purple-900 to-indigo-900 border-4 border-purple-500 p-8 max-w-md w-full">
        <h2 className="text-3xl font-black text-purple-400 uppercase mb-4 text-center">
          INSTALL SENDITMAXX
        </h2>
        <p className="text-white font-bold text-center mb-6">
          Add to your home screen for daily reminders and instant access. No app store needed.
        </p>
        <div className="flex flex-col gap-3">
          <button
            onClick={async () => {
              if (deferredPrompt) {
                deferredPrompt.prompt();
                const { outcome } = await deferredPrompt.userChoice;
                console.log(`User response: ${outcome}`);
                setDeferredPrompt(null);
              }
              setShowPWAPrompt(false);
              storage.setPWAPromptSeen(true);
            }}
            className="w-full bg-gradient-to-r from-purple-600 to-indigo-600 hover:from-purple-500 hover:to-indigo-500 text-white py-4 font-black text-lg uppercase border-3 border-purple-400 transition-all"
          >
            📲 INSTALL NOW
          </button>
          <button
            onClick={() => {
              setShowPWAPrompt(false);
              storage.setPWAPromptSeen(true);
            }}
            className="w-full bg-transparent text-purple-400 py-3 font-black text-sm uppercase border-2 border-purple-500 hover:bg-purple-900/30 transition-all"
          >
            MAYBE LATER
          </button>
        </div>
      </div>
    </div>
  );
};
